// extracted by mini-css-extract-plugin
export default {"column":"WalletSuccessModal_column__mS88o","label":"WalletSuccessModal_label__a2Qpu","button":"WalletSuccessModal_button__IELSi"};